// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PregledOstalihVoditelja_paginationContainer__tlyWR {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #d1d9e2;
  border-right: 1px solid #d1d9e2;
  border-bottom: 1px solid #d1d9e2;
  padding: 16px 0px;
}

.PregledOstalihVoditelja_dateChangeContainer__bIsjr {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: fit-content;
}

.PregledOstalihVoditelja_dateChangeText__RjoU3 {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  color: #5f6d7e;
}

.PregledOstalihVoditelja_dateChangeInput__EZMjC {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  color: #5f6d7e;
  padding: 7px;
  border-radius: 6px;
  outline: none;
  border: 1px solid #dbdbdb;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
}

.PregledOstalihVoditelja_btnContainer__bVzT4 {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PregledOstalihVoditelja_cancelButton__\\+RoyS {
  width: 100px;
  height: 40px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #ebebeb;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #808080;
  cursor: pointer;
}
.PregledOstalihVoditelja_saveButton__18G-R {
  width: 100px;
  height: 40px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #cb9c2d;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.PregledOstalihVoditelja_cancelButton__\\+RoyS:hover {
  background-color: #d1d0d0;
}
.PregledOstalihVoditelja_saveButton__18G-R:hover {
  background-color: #ac8427;
}

.PregledOstalihVoditelja_searchInput__-sZOO {
  border: 1px solid #d9dce0;
  height: 46px;
  padding: 8px 16px 8px 46px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(186, 197, 210, 0.6);
  border: 1px solid #d9dce0;
  width: 400px;
  border-radius: 8px;
  margin-bottom: 30px;
}
.PregledOstalihVoditelja_searchInput__-sZOO::placeholder {
  color: rgba(95, 109, 126, 0.6);
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.PregledOstalihVoditelja_searchInput__-sZOO:focus {
  border: 1px solid rgba(203, 156, 45, 1);
  outline: none;
}

.PregledOstalihVoditelja_searchIcon__QiN9V {
  height: 24px;
  margin: 10px 16px 0px;
  position: absolute;
  width: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/OsvrtiNaVoditelja/components/PregledOstalihVoditelja/PregledOstalihVoditelja.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,qDAAqD;EACrD,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #d1d9e2;\n  border-right: 1px solid #d1d9e2;\n  border-bottom: 1px solid #d1d9e2;\n  padding: 16px 0px;\n}\n\n.dateChangeContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: fit-content;\n}\n\n.dateChangeText {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  color: #5f6d7e;\n}\n\n.dateChangeInput {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  color: #5f6d7e;\n  padding: 7px;\n  border-radius: 6px;\n  outline: none;\n  border: 1px solid #dbdbdb;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n}\n\n.btnContainer {\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cancelButton {\n  width: 100px;\n  height: 40px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #ebebeb;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n}\n.saveButton {\n  width: 100px;\n  height: 40px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #cb9c2d;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancelButton:hover {\n  background-color: #d1d0d0;\n}\n.saveButton:hover {\n  background-color: #ac8427;\n}\n\n.searchInput {\n  border: 1px solid #d9dce0;\n  height: 46px;\n  padding: 8px 16px 8px 46px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 10px 0px rgba(186, 197, 210, 0.6);\n  border: 1px solid #d9dce0;\n  width: 400px;\n  border-radius: 8px;\n  margin-bottom: 30px;\n}\n.searchInput::placeholder {\n  color: rgba(95, 109, 126, 0.6);\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.searchInput:focus {\n  border: 1px solid rgba(203, 156, 45, 1);\n  outline: none;\n}\n\n.searchIcon {\n  height: 24px;\n  margin: 10px 16px 0px;\n  position: absolute;\n  width: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationContainer": `PregledOstalihVoditelja_paginationContainer__tlyWR`,
	"dateChangeContainer": `PregledOstalihVoditelja_dateChangeContainer__bIsjr`,
	"dateChangeText": `PregledOstalihVoditelja_dateChangeText__RjoU3`,
	"dateChangeInput": `PregledOstalihVoditelja_dateChangeInput__EZMjC`,
	"btnContainer": `PregledOstalihVoditelja_btnContainer__bVzT4`,
	"cancelButton": `PregledOstalihVoditelja_cancelButton__+RoyS`,
	"saveButton": `PregledOstalihVoditelja_saveButton__18G-R`,
	"searchInput": `PregledOstalihVoditelja_searchInput__-sZOO`,
	"searchIcon": `PregledOstalihVoditelja_searchIcon__QiN9V`
};
export default ___CSS_LOADER_EXPORT___;
